import React from "react";
import { Link } from "gatsby";
import { MdLibraryBooks } from "react-icons/md";
import "./styles.scss";

function UtilityNav() {
	return (
		<nav aria-label="utility-navigation">
			<ul className="utility-nav">
				<li>
					<Link to="/news" className="utility-nav__news-link">
						<MdLibraryBooks
							aria-hidden="true"
							size={20}
							className="utility-nav__news-link-item"
						/>
						<span className="utility-nav__news-link-item utility-nav__news-link-item--white">
							Titan Musings
						</span>
						<span className="utility-nav__news-link-item">News</span>
					</Link>
				</li>
				<li>
					<Link to="/contact" className="btn btn--green-white btn--sm">
						Contact Us
					</Link>
				</li>
			</ul>
		</nav>
	);
}

export default UtilityNav;
